import axios from "axios";

import { url_api } from "../config";

const api = axios.create({
  baseURL: url_api,
  timeout: 60000,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json;charset=utf-8",
  },
});

export default api;
